import { DepartmentPlanDeal } from "../../../model/dashboard.types";

export type DealColumnId =
  | "deal"
  | "client"
  | "opportunity"
  | "profit"
  | "marginality"
  | "actual_paid"
  | "stage_id"
  | "responsible";

export type DealGroupKey = "client" | "responsible";

export const DEAL_COLUMNS: {
  id: DealColumnId;
  label: string;
  groupable?: boolean;
  numeric?: boolean;
  /** Не суммировать в строках групп */
  noGroupSum?: boolean;
}[] = [
  { id: "deal", label: "Сделка" },
  { id: "client", label: "Клиент", groupable: true },
  { id: "opportunity", label: "Оборот", numeric: true },
  { id: "profit", label: "Валовая прибыль", numeric: true },
  { id: "marginality", label: "Маржинальность", numeric: true, noGroupSum: true },
  { id: "actual_paid", label: "Оплачено", numeric: true },
  { id: "stage_id", label: "Этап" },
  { id: "responsible", label: "Ответственный", groupable: true },
];

export const DEAL_GROUP_OPTIONS: { id: DealGroupKey; label: string }[] = [
  { id: "client", label: "Компания" },
  { id: "responsible", label: "Сотрудник" },
];

export const DEFAULT_VISIBLE_COLUMNS: DealColumnId[] = DEAL_COLUMNS.map((c) => c.id);

/** Столбцы, которые нельзя скрыть */
export const REQUIRED_VISIBLE_COLUMNS: DealColumnId[] = ["deal", "client"];

export const GROUP_KEY_ORDER: DealGroupKey[] = ["client", "responsible"];

export function getDealGroupValue(deal: DepartmentPlanDeal, key: DealGroupKey): string {
  if (key === "client") {
    return deal.client?.trim() || "—";
  }
  return deal.responsible?.trim() || "—";
}

export function sumDealNumericField(
  deals: DepartmentPlanDeal[],
  field: "opportunity" | "profit" | "actual_paid"
): number {
  return deals.reduce((sum, deal) => sum + deal[field], 0);
}

export function formatDealMoney(value: number): string {
  return `${value.toLocaleString("ru-RU")} ₽`;
}

export function formatDealMarginality(value: number | undefined | null): string {
  if (value == null || Number.isNaN(value)) {
    return "—";
  }
  return `${value.toLocaleString("ru-RU", { maximumFractionDigits: 1 })}%`;
}
